module.exports = __webpack_public_path__ + "img/agreement.f99ea1e3.png";